export const Dashboard_PortfolioScheme = [
    {
        CompanyName:"Reliance",
        quantity:6,
        currentAmt:"₹ 2000",
        DividendReceived:"25.3%",
        DividendUnpaid:"₹ 2000"
    },
    {
        CompanyName:"Bharati Airtel",
        quantity:6,
        currentAmt:"₹ 2000",
        DividendReceived:"25.3%",
        DividendUnpaid:"₹ 2000"
    },
    {
        CompanyName:"ITC",
        quantity:6,
        currentAmt:"₹ 2000",
        DividendReceived:"25.3%",
        DividendUnpaid:"₹ 2000"
    }
]